import { Link, useLocation } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { BLOG_POSTS } from "@/content/blogPosts";

interface BlogBreadcrumbProps {
  /** Optional override; defaults to looking up the title from BLOG_POSTS by route slug. */
  title?: string;
}

/**
 * Visible breadcrumb shown at the top of every blog post.
 * BreadcrumbList JSON-LD is emitted in each post's SEOHead,
 * so this component is presentation-only.
 */
export const BlogBreadcrumb = ({ title }: BlogBreadcrumbProps) => {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\/blog\//, "").replace(/\/$/, "");
  const lookup = BLOG_POSTS.find((p) => p.slug === slug)?.title;
  const label = title || lookup || "Article";

  return (
    <nav className="container mx-auto px-4 pt-6">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/">Home</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/blog">Blog</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage className="line-clamp-1">{label}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </nav>
  );
};
